import {
  Loading,
  QUERIES,
  getPaymentCards,
  increaseUsage,
  scrollBarStyles,
} from "@dataone/lib";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";
import { useEffect, useState } from "react";
import { ProductData } from "./Modal";
import { MasterCardIcon, VisaCardIcon } from "@dataone/icons";
import dayjs from "dayjs";
interface PaymentModalProps {
  isSearchIncrease: boolean;
  isPromptChartUpdate?: boolean;
  searchData: ProductData;
  setCardId: (value: string) => void;
  onSuccess: boolean;
}

const PaymentModal = ({ setCardId, onSuccess }: PaymentModalProps) => {
  const navigate = useNavigate();
  const {
    data: cards,
    isLoading: isCardsLoading,
    refetch: refetchCards,
  } = useQuery({
    queryKey: [QUERIES.PAYMENT_CARDS],
    queryFn: getPaymentCards,
    onError: () => navigate("/profile"),
  });

  const [selectedCard, setSelectedCard] = useState<string>("");
  const handleSelectCard = (cardId: string) => {
    setSelectedCard(cardId);
  };

  useEffect(() => {
    if (cards?.length) {
      setSelectedCard(cards[0].id);
    }
    if (onSuccess) {
      refetchCards();
    }
  }, [cards]);

  return (
    <StyledPaymentModal>
      <StyledHeader>
        <h2>Payment method </h2>
      </StyledHeader>
      <StyledContent>
        {isCardsLoading ? (
          <Loading />
        ) : !cards?.length ? (
          <>No card found</>
        ) : (
          cards.map((card) => (
            <>
              <StyledInfoCard
                $ISelected={selectedCard === card.id}
                onClick={() => {
                  handleSelectCard(card.id);
                  setCardId(card.id);
                }}
              >
                {card.brand === "visa" ? <VisaCardIcon /> : <MasterCardIcon />}
                <div>
                  <h4>
                    {card.brand} ending in {card.last4}
                  </h4>
                  <p>
                    Exp. dat
                    {dayjs(`${card.expYear}-${card.expMonth}`).format(" M/YY ")}
                  </p>
                </div>
                {card.defaultCard && <DefaultSymbol>Default</DefaultSymbol>}
                {/* <Button
                type="link"
                disabled={increaseUsageLoading}
                onClick={() => handleIncreaseUsage(card.id)}
                icon={
                  increaseUsageLoading && selectedCard === card.id ? (
                    <LoadingOutlined />
                  ) : (
                    <img alt="card" src="/images/profile/arrow-right.svg" />
                  )
                }
              ></Button> */}
              </StyledInfoCard>
            </>
          ))
        )}
      </StyledContent>
    </StyledPaymentModal>
  );
};

export default PaymentModal;

const StyledPaymentModal = styled.div`
  height: 100%;
`;
const StyledInfoCard = styled.div<{ $ISelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 25px;
  margin-bottom: 15px;
  height: 70px;
  // width: 60%;
  width: 435px;
  border-radius: 10px;
  background-color: ${(p) => (p.$ISelected ? "#eff1fd" : "#fff")};
  cursor: pointer;
  &:hover {
    background-color: #eff1fd;
  }

  // > div {
  //   flex: 1;
  // }
  h4 {
    margin-block: 0 6px;
    text-transform: capitalize;
  }
  p {
    margin: 0;
  }

  .ant-btn {
    width: auto;
    height: auto;
    padding: 0;
  }

  svg {
    font-size: 50px;
  }
`;
const StyledHeader = styled.div`
  margin-top: -10px;
  h2 {
    color: #4974f6;
    font-weight: 700;
    font-size: 25px;
    margin-top: 2px;
  }
`;
const StyledContent = styled.div`
  // height: 74%;

  overflow: auto;
  padding-top: 40px;
  width: 100%;
  display: flex;
  height: 360px;
  flex-direction: column;
  align-items: center;
  ${scrollBarStyles};
`;
const DefaultSymbol = styled.div`
  margin-left: auto;
  background-color: #4974f6;
  font-size: 16px;
  padding: 4px 16px;
  border-radius: 10px;
  color: #fff;
`;
